// extracted by mini-css-extract-plugin
export var childrenContent = "bP_fN";
export var content = "bP_R";
export var titleContent = "bP_fP";
export var titleContentLabel = "bP_fQ";